export default __webpack_public_path__ + "favicons/mstile-310x310.png";